<template>
	<div class="HomeServerStatus">
		<div class="statusPanel">
			<div class="panelInnder">
				<ChartProgress header="CPU Kullanımı" :footer="status.cpu.percent+'%'" :value="status.cpu.percent" critical="75" :isLoading="isLoading"/>
			</div>
		</div>
		<div class="statusPanel">
			<div class="panelInnder">
				<ChartProgress header="RAM Kullanımı" :footer="status.ram.used_format+'/'+status.ram.total_format" :value="status.ram.percent" critical="75" :isLoading="isLoading"/>
			</div>
		</div>
		<div class="statusPanel">
			<div class="panelInnder">
				<ChartProgress header="DISK Kullanımı" :footer="status.disk.used_format+'/'+status.disk.total_format" :value="status.disk.percent" critical="85" :isLoading="isLoading"/>
			</div>
		</div>
		<div class="statusPanel">
			<div class="panelInnder">
				<ChartProgress header="Bandwith" :footer="status.bandwith.used_format+'/'+status.bandwith.total_format" :value="status.bandwith.percent" critical="75" :isLoading="isLoading"/>
			</div>
		</div>
		<div class="statusPanel">
			<div class="panelInnder">
				<ChartProgress header="Load Avarage" :footer="status.loadAvarage.used+'/'+status.loadAvarage.total" :value="status.loadAvarage.percent" critical="10" :isLoading="isLoading"/>
			</div>
		</div>
	</div>
</template>

<script>
	import ChartProgress from "@/components/tools/ChartProgress";
	export default {
		name: "HomeServerStatus",
		components: {
			ChartProgress
		},
		data: () => ({
			isLoading : true,
			status: {
				"cpu": {
					"percent": 0
				},
				"ram": {
					"total": 0,
					"total_format": "0 GB",
					"used": 0,
					"used_format": "0 GB",
					"free": 0,
					"free_format": "0 GB",
					"percent": 0
				},
				"disk": {
					"total": 0,
					"total_format": "0 GB",
					"used": 0,
					"used_format": "0 GB",
					"free": 0,
					"free_format": "0 GB",
					"percent": 0
				},
				"loadAvarage": {
					total: 0,
					used: 0,
					free: 0,
					percent: 0
				},
				"bandwith": {
					"total": 0,
					"total_format": "0 TB",
					"used": 0,
					"used_format": "0 GB",
					"free": 0,
					"free_format": "0 TB",
					"percent": 0
				}
			}
		}),
		mounted(){
			this.loadStatus()
		},
		methods : {
			loadStatus(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/server/status", {
					params : { }
				}).then(response => {  
					this.status = response.body;
					this.isLoading = false; 
				}) 
			}
		}
	}
</script>


<style lang="less">
	.HomeServerStatus {
		&::after {
			content: '';
			clear: both;
			display: table;
		}

		.statusPanel {
			float: left;
			width: calc(~"100% / 5");
			@media(max-width:750px){
				width: calc(~"100% / 3");
			}
			@media(max-width:600px){
				width: calc(~"100% / 2");
			}
			.panelInnder {
				margin: 5px;
			}
		}
	}
</style>